export default {
  getFriendLinks: 'v1/links',
  saveData: 'v1/browse/info',
  getInfo: 'v1/get/ip',
  conversion: 'v1/currency/conversion',
  dns: 'v1/get/dns',
}



// WEBPACK FOOTER //
// ./src/utils/APIPath.js